import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import {
  StandingOrder,
  StandingOrderItemTableResponse,
  StandingOrderTableResponse,
} from "@/models/api/administration/contractors/ContractorStandingOrder";

export const URL_GET_CONTRACTOR_STANDING_ORDERS = "/ContractorAdministration/${ContractorId}/StandingOrders/Paged";
export const URL_GET_CONTRACTOR_STANDING_ORDER_ITEMS =
  "/ContractorAdministration/${ContractorId}/StandingOrders/${StandingOrderId}/Items/Paged";

export const URL_POST_CONTRACTOR_STANDING_ORDER = "/ContractorAdministration/StandingOrders/${StandingOrderId}";

export const URL_POST_CONTRACTOR_STANDING_ORDER_EDIT =
  "/ContractorAdministration/StandingOrders/${StandingOrderId}/Edit";
export const URL_POST_CONTRACTOR_STANDING_ORDER_REMOVE =
  "/ContractorAdministration/StandingOrders/${StandingOrderId}/Remove";

const _getContractorStandingOrders = new CancellableHelper<StandingOrderTableResponse>(
  URL_GET_CONTRACTOR_STANDING_ORDERS,
  StandingOrderTableResponse
);
_getContractorStandingOrders.jsonSerializer = true;
export const getContractorStandingOrders = async (genericTableRequest: GenericTableRequest, contractorId: string) => {
  return _getContractorStandingOrders.get({
    ContractorId: contractorId,
    ...genericTableRequest,
  });
};

const _getContractorStandingOrderItems = new CancellableHelper<StandingOrderItemTableResponse>(
  URL_GET_CONTRACTOR_STANDING_ORDER_ITEMS,
  StandingOrderItemTableResponse
);
_getContractorStandingOrderItems.jsonSerializer = true;
export const getContractorStandingOrderItems = async (
  genericTableRequest: GenericTableRequest,
  contractorId: string,
  standingOrderId: string
) => {
  return _getContractorStandingOrderItems.get({
    ContractorId: contractorId,
    StandingOrderId: standingOrderId,
    ...genericTableRequest,
  });
};

const _removeStandingOrder = new CancellableHelper<null>(URL_POST_CONTRACTOR_STANDING_ORDER_REMOVE);
export const removeStandingOrder = async (standingOrderId: string) => {
  return _removeStandingOrder.post({
    StandingOrderId: standingOrderId,
  });
};

const _editStandingOrder = new CancellableHelper<null>(URL_POST_CONTRACTOR_STANDING_ORDER_EDIT);
export const editStandingOrder = async (standingOrderId: string, model: StandingOrder) => {
  return _editStandingOrder.post(
    {
      StandingOrderId: standingOrderId,
    },
    model
  );
};

const _downloadStandingOrder = new CancellableHelper<StandingOrder>(URL_POST_CONTRACTOR_STANDING_ORDER);
export const downloadStandingOrder = async (standingOrderId: string) => {
  return _downloadStandingOrder.get({
    StandingOrderId: standingOrderId,
  });
};
